import { io } from "socket.io-client";

const API_BASE_URL = "wss://webhook.silulumanzi.com:90";

const socket = io(API_BASE_URL, { 
  transports: ['websocket'], // Force only websocket for debugging
  timeout: 10000, 
});

socket.on("connect", () => {
  console.log("Connected to server");
});

socket.on("connect_error", (error) => {
  console.error("Connection error:", error);
});

socket.on("disconnect", (reason) => {
  console.log("Disconnected:", reason);
});

export default socket;